import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  max-width: 1124px;
  padding-bottom: 64px;
`;
export const FormReconciliationReport = styled.form`
  width: 100%;
  max-width: 800px;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 0.4fr;
  gap: 16px;
  align-items: end;
  margin-bottom: 32px;
`;

export const Table = styled.table`
  max-width: 78.75rem;
  width: 100%;
  box-shadow: 4px 4px 6px rgba(0, 0, 0, 0.2);
  background: #f6f6f6;
  border-collapse: collapse;
  background-color: ${(props) => props.theme.colors.borderColor};

  .fixeSize {
    width: 30rem;
    padding: 0.5rem 1.5rem;
  }

  .bg-orange {
    background-color: ${(props) => props.theme.colors["orange-100"]};
  }

  .textSmall {
    font-size: 0.75rem;
  }

  & td {
    border: 1px solid ${(props) => props.theme.colors.borderColor};
  }
`;

export const TableHead = styled.thead`
  background: #1d1d1b;

  > tr {
    color: #fff;
    text-align: center;
    font-size: 1rem;
    font-style: normal;
    font-weight: 500;

    > td {
      padding: 1.5rem 0;
    }
  }
`;

export const TableBody = styled.tbody`
  background: #f6f6f6;

  td {
    height: 3rem;
    text-align: center;
    color: #a3a3a3;
    text-align: center;
    font-size: 1rem;
    font-style: normal;
    font-weight: 500;
    line-height: 1.25rem;
  }
`;

export const RankingContainer = styled.div`
  border-radius: 8px;
  border: 1px solid #2d2d2d;
  box-shadow: 4px 4px 4px 0 rgba(0, 0, 0, 0.25);
  padding: 25px 32px;
  width: 100%;
  max-width: 600px;
  margin-top: 36px;
`;

export const RankingHeader = styled.div`
  position: relative;
  display: flex;
  gap: 5px;
  margin-bottom: 24px;

  > div {
    height: 54px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    > h2 {
      color: #000;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 20px;
    }

    > p {
      color: #000;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 125% */
    }
  }

  &::before {
    content: "";
    display: block;
    position: relative;
    width: 16px;
    background-color: #a3a3a3;
    height: 54px;
    left: 0;
  }
`;

export const RankingContent = styled.div`
  > div + div {
    margin-top: 16px;
  }
`;

export const RankingItem = styled.div`
  display: flex;
  justify-content: space-between;
  height: 40px;
  align-items: center;

  p {
    color: #000;
    display: flex;
    align-items: center;
    gap: 12px;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  span {
    color: #000;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
  }

  &.first-position {
    p {
      font-weight: 700;

      img {
        filter: brightness(0) saturate(100%) invert(83%) sepia(18%)
          saturate(6462%) hue-rotate(3deg) brightness(111%) contrast(102%);
      }
    }
    span {
      font-weight: 700;
      display: flex;
      align-items: center;
      border-radius: 5px;
      background: #e84e1b;
      height: 100%;
      width: fit-content;
      padding: 0 16px;
    }
  }
`;

export const TitleSection = styled.h2`
  color: #000;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: 20px;
  margin-bottom: 32px;
`;

export const GridContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 1.8fr;
  gap: 64px;
`;

export const WrapperImgButton = styled.div`
  border-radius: 100px;
  background: rgba(255, 255, 255, 0.1);
  padding: 5px;
  width: 48px;
  height: 48px;
  display: flex;
  justify-content: center;
  align-items: center;

  > img {
    display: block;
  }
`;

export const ButtonDocDown = styled.button`
  border-radius: 5px;
  background: #e84e1b;
  box-shadow: 4px 4px 4px 0 rgba(0, 0, 0, 0.25);
  height: 78px;
  width: fit-content;
  padding: 16px;
  display: flex;
  gap: 16px;
  justify-content: center;
  align-items: center;
  border: none;

  > span {
    color: #fff;
    text-align: center;
    font-family: "Noto Sans";
    font-size: 20px;
    font-style: normal;
    font-weight: 700;
    line-height: 20px; /* 100% */
  }
`;
